<template>
  <div class="modal-overlay">
    <div class="context">
      <div class="close-btn" @click="closeVideoModal">
        <img src="../../assets/images/close-2.svg" alt="close">
      </div>
      <div class="name">Candidate Name: {{applicantName}}</div>
      <video width="640" height="480" controls>
        <source :src="videoUrl" type="video/mp4">
      </video>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoModal',
  props: ['videoUrl', 'applicantName'],
  methods: {
    closeVideoModal() {
      this.$emit('closeVideoModal');
    },
  },
};
</script>

<style scoped>
  .modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 20;
    background: rgba(20, 20, 20, 0.83);
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }
  .modal-overlay .context {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 21;
    width: 100%;
    height: 100%;
    background: #222222;
    max-width: 921px;
    max-height: 654px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .close-btn{
    width: 30px;
    height: 30px;
    background: var(--colorPrimary);
    border-radius: 50%;
    padding: 5px;
    position: absolute;
    top: 30px;
    right: 30px;
    cursor: pointer;
  }
  .modal-overlay .context .name {
    font-size: 1.5rem;
    line-height: 2.125rem;
    color: var(--white);
  }
  .modal-overlay .context p {
    font-size: 1.25rem;
    line-height: 2.125rem;
  }
</style>
